// angular
import {Component} from "@angular/core";
import {RouterLink} from "@angular/router";
// material angular
import {MatIconModule} from "@angular/material/icon";

@Component({
  selector: "app-messaging-menu",
  templateUrl: "./messaging-menu.component.html",
  styleUrls: ["./messaging-menu.component.scss"],
  standalone: true,
  imports: [MatIconModule, RouterLink],
})
export class MessagingMenuComponent {}
